<template>
	<div class="wrapper main-wrapper">
		<div class="main">
			<slot/>
		</div>
		<aside class="sidebar" :class="{'nosupport': props.support == false}" v-if="!mobileBreakpoint">
			<div class="sidebar-panel">
				<div class="sidebar-panel-body">
					<BaseCmsNav code="sidebar" v-slot="{items, currentUrl}">
						<ul class="nav" v-if="items?.length">
							<li v-for="item in items" :key="item.id">
								<NuxtLink :to="item.url_without_domain" :class="{'active': currentUrl == item.url_without_domain}">{{ item.title }}</NuxtLink>
							</li>
						</ul>
					</BaseCmsNav>
					<div class="sidebar-cnt" v-if="props.support">
						<CmsSupport class="support-sidebar" />
						<CmsSocial class="social2" />
					</div>
				</div>
			</div>
			<slot name="sidebar"/>
		</aside>
	</div>
</template>

<script setup>
	const {mobileBreakpoint} = inject('rwd');
	const props = defineProps({
		support: {
			type: Boolean,
			default: true
		}
	});
</script>

<style scoped lang="less">
	*{
		--sidebarPadding: 40px;
	}
	.main-wrapper{
		display: flex; gap: 20%; padding-bottom: 60px;
		@media (max-width: @ds){gap: 10%;}
		@media (max-width: @t){gap: 30px;}	
		@media (max-width: @m){gap: 0; padding-bottom: 32px;}
	}
	.main{
		flex-grow: 1; padding-top: 40px;
		@media (max-width: @m){padding-top: 0; width: 100%;}	
	}
	.sidebar{
		flex: 0 0 370px;
		@media (max-width: @t){width: 320px;}	
	}
	.sidebar-panel{
		margin-top: -75px; position: relative; z-index: 5;
		&:after{.pseudo(auto,12px); background: var(--blue2); border-radius: 0 0 6px 6px; bottom: -12px; left:  var(--sidebarPadding); right:  var(--sidebarPadding); z-index: 0;}
	}
	.sidebar-panel-body{background: #fff; border-radius: 8px; position: relative; z-index: 1; box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.1);}
	.nav{
		list-style: none; overflow: hidden; border-radius: 8px 8px 0 0;
		li{border-bottom: 1px solid var(--borderColor);}
		a{
			text-decoration: none; color: var(--textColor); padding: 14px var(--sidebarPadding); display: flex; align-items: center; justify-content: space-between; transition: background 0.3s, color 0.3s; position: relative;
			&:after{.icon-arrow(); font: 10px/1 var(--fonti); opacity: 0; .transition(opacity);}
			&:hover{
				background: var(--blue2); color: #fff;
				&:after{opacity: 1;}
			}
			&.active{
				background: var(--lightGray); color: var(--darkGray);
				&:after{display: none;}
			}
		}
	}
	.sidebar-cnt{padding: 25px  var(--sidebarPadding) 35px;}
	.nosupport{
		.sidebar-panel:after{display: none;}
		.nav{
			border-radius: 8px;
			li:last-child{border: 0;}
		}
	}
</style>